/**
 * Types for Health Plan Card Upload OCR feature
 */
export enum CardSide {
  FRONT = 'FRONT',
  BACK = 'BACK',
}

export enum UploadStatus {
  IDLE = 'IDLE', // Front-end only, to mark initial state before upload
  UPLOAD_PROCESSING = 'UPLOAD_PROCESSING', // Initial status when upload starts
  UPLOADED = 'UPLOADED', // Upload completed successfully to backend, ready for OCR
  UPLOAD_FAILED = 'UPLOAD_FAILED', // Upload failed (file validation, S3 error, etc.)
}

export enum OcrStatus {
  OCR_PROCESSING = 'OCR_PROCESSING',
  OCR_COMPLETED = 'OCR_COMPLETED',
  OCR_FAILED = 'OCR_FAILED',
}

export type HealthPlanCardStatus = UploadStatus | OcrStatus

export interface HealthPlanCardUploadResponse {
  originalFilename?: string
  contentType: string | null
  cardSide: CardSide
  status: HealthPlanCardStatus
  taskId: string
  error?: {
    code: string
    message: string
  }
}

export interface HealthPlanCardUploadRequest {
  patientLyraId: string
  file: File
  cardSide: CardSide
}

// Backend error codes (from HealthPlanCardErrorCode.java)
export enum HealthPlanCardUploadErrorCode {
  INVALID_FILE = 'INVALID_FILE', // Null or empty file
  UNSUPPORTED_FILE_TYPE = 'UNSUPPORTED_FILE_TYPE', // File type not in allowed list
  METADATA_ERROR = 'METADATA_ERROR', // Database error creating upload record
  PATIENT_ERROR = 'PATIENT_ERROR', // Patient not found
  UPLOAD_ERROR = 'UPLOAD_ERROR', // S3 upload / encryption failure
  OCR_PROCESSING_FAILED = 'OCR_PROCESSING_FAILED',
  FILE_TOO_LARGE = 'FILE_TOO_LARGE',
  NETWORK_ERROR = 'NETWORK_ERROR', // Axios network error (no connection, timeout, etc.)
}

export interface ExtractedValues {
  firstName?: string
  lastName?: string
  memberId?: string
}

export interface OcrPollResponse {
  contentType?: string
  cardSide: CardSide
  status: HealthPlanCardStatus
  taskId: string
  extractedValues?: ExtractedValues
  error?: {
    code: string
    message: string
  }
}
